import Reveal from "@/components/Reveal";
import { HeartHandshake, ArrowRight } from "lucide-react";

const IMAGE = "/shared-room-2.jpg";

export default function WhoWeHelp() {
  return (
    <section id="who-we-help" className="py-20 sm:py-28" data-testid="who-we-help-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <Reveal>
          <div className="relative">
            <div className="rounded-[2rem] overflow-hidden shadow-[0_24px_60px_rgba(0,0,0,0.12)]">
              <img
                src={IMAGE}
                alt="A modest bedroom with twin beds in a shared home"
                className="w-full h-[320px] sm:h-[440px] object-cover"
                data-testid="who-we-help-image"
              />
            </div>
            <div className="absolute -bottom-6 right-6 bg-[#FF5A5F] text-white rounded-2xl px-6 py-4 shadow-[0_12px_32px_rgba(255,90,95,0.4)]">
              <p className="text-xs font-bold tracking-widest uppercase opacity-80">Our Mission</p>
              <p className="text-sm font-bold mt-1">Helping end homelessness, one room at a time</p>
            </div>
          </div>
        </Reveal>

        <div>
          <Reveal>
            <p className="text-sm font-bold tracking-[0.2em] uppercase text-[#FF5A5F]">Who We Help</p>
            <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-[#222]">
              A Welcoming Door for Anyone Who Needs Housing
            </h2>
            <p className="mt-5 text-base sm:text-lg leading-relaxed text-[#5a5a5a]">
              We help adults looking for a private or shared room, people going through a housing
              transition, and people looking for a more affordable place to live. We also work with
              families, caseworkers, and community organizations helping someone find housing.
            </p>
            <p className="mt-4 text-base sm:text-lg leading-relaxed text-[#5a5a5a]">
              We believe everyone deserves a safe, stable place to live. By making rooms in shared
              homes available across Central Florida, we do our part to help end homelessness — one
              room at a time.
            </p>
            <a
              href="/#contact"
              data-testid="who-we-help-cta"
              className="mt-7 inline-flex items-center gap-2 bg-[#FF5A5F] hover:bg-[#E0484D] text-white font-bold px-7 py-3.5 rounded-full transition-all duration-200 shadow-[0_8px_24px_rgba(255,90,95,0.35)] hover:-translate-y-0.5"
            >
              <HeartHandshake className="w-5 h-5" />
              Contact Us for Housing
              <ArrowRight className="w-4 h-4" />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
